PluginManager.register('StickyCartPlugin', () => import('./plugins/sticky-cart.plugin'), '#cob-sticky-cart');
